import jet from "@randajan/jet-core";
import { map } from "@randajan/jet-core/eachSync";

const { solid, cached } = jet.prop;

const fieldTypes = {
    number:{ check:v=>v, to:(v, {min, max, decimal})=>Number.jet.round(Number.jet.frame(Number.jet.to(v), min, max), decimal) },
    text:{ check:v=>v, to:(v, {max})=>String.jet.to(v).slice(0, max) },
    email:{ check:v=>v, to:(v, {max})=>String.jet.to(v).slice(0, max) },
    tel:{ check:v=>v, to:(v, {max})=>String.jet.to(v).slice(0, max) },
    textarea:{ check:v=>v, to:(v, {max})=>String.jet.to(v).slice(0, max) },
    password:{ check:v=>v, to:(v, {max})=>String.jet.to(v).slice(0, max) },
}

export class FormSchema {
    constructor(name, fields) {
        solid.all(this, {
            name,
            fields
        });
    }

    extract(input) {
        return map(this.fields, (field, {key})=>{
            const type = fieldTypes[field.type];
            const value = input[key];
            if (!field.noNull && (value == null || value == "")) { return; }
            return type.to(value, field);
        });
    }

}

